import React from "react";
import "./index.scss";
import { Button, Typography } from "components/atoms";
import classNames from "classnames";
import { PracticeModalIcon } from "components/atoms/Icon";

interface IProps {
  theme: "light" | "dark";
  modalSelector: "both" | "paper & pencil";
  type: "online" | "bubble-sheet";
  isPdfUrl: boolean;
  title: string;
  description: string;
  btnLabel: string;
  onlineProctor_1?: string;
  onlineProctor_2?: string;
  onlineProctor_3?: string;
  launchUrl?: string;
  pdfUrl?: string;
  handleModalClose?: () => void;
  handleRefreshModalOpen?: () => void;
}

export const PracticeModalInnerCard = ({
  modalSelector,
  type,
  isPdfUrl,
  title,
  description,
  btnLabel,
  onlineProctor_1,
  onlineProctor_2,
  onlineProctor_3,
  launchUrl,
  pdfUrl,
  theme,
  handleModalClose,
  handleRefreshModalOpen,
}: IProps) => {
  const handleProctorUrlClick = (url: string) => {
    window.open(url, "__blank");
    handleModalClose && handleModalClose();
    handleRefreshModalOpen && handleRefreshModalOpen();
  };

  const handleBtnClick = () => {
    if (launchUrl) {
      window.open(launchUrl, "__blank");
    }
    handleModalClose && handleModalClose();
    handleRefreshModalOpen && handleRefreshModalOpen();
  };

  const handlePdfDownload = () => {
    if (pdfUrl) {
      window.open(pdfUrl, "__blank");
    }
    handleModalClose && handleModalClose();
    handleRefreshModalOpen && handleRefreshModalOpen();
  };

  return (
    <div
      className={classNames(`${type}`)}
      style={
        theme === "dark"
          ? modalSelector === "both"
            ? { backgroundColor: "rgba(61, 68, 77, 0.20)" }
            : { backgroundColor: "#1C1F23" }
          : modalSelector === "both"
            ? { backgroundColor: "#ebf1f9" }
            : { backgroundColor: "#ffffff" }
      }
    >
      <div className="left-right-wrapper">
        <div className="left-section">
          <div className="title">
            <Typography
              label={title}
              variant="h2Med"
              styles={
                theme === "dark"
                  ? "custom-title-typography-dark"
                  : "custom-title-typography-light"
              }
            />
          </div>
          <div className="description">
            <Typography
              label={description}
              variant="h8Med"
              styles={
                theme === "dark"
                  ? "custom-description-typography-dark"
                  : "custom-title-typography-light"
              }
            />
          </div>
          <div className="btn-section">
            <Button
              label={btnLabel}
              type="score"
              icon={false}
              onClick={handleBtnClick}
              styles={theme === "dark" ? "score-btn-dark" : ""}
            />
            {isPdfUrl && type === "bubble-sheet" ? (
              <Button
                label="Download Exam PDF"
                type="online"
                icon={false}
                onClick={handlePdfDownload}
                styles={theme === "dark" ? "online-btn-dark" : ""}
              />
            ) : null}
          </div>
        </div>
        <div className="right-section">
          <PracticeModalIcon
            theme={theme}
            containerWidth={163}
            containerHeight={163}
            isScoreReport={type === "bubble-sheet"}
          />
        </div>
      </div>

      {onlineProctor_1 || onlineProctor_2 || onlineProctor_3 ? (
        <div className="proctor-section">
          {onlineProctor_1 ? (
            <div
              className="procter_1"
              onClick={() => handleProctorUrlClick(onlineProctor_1)}
            >
              <Typography
                label="Online Proctor"
                variant="h9Book"
                styles="custom-proctor-typography-style"
              />
            </div>
          ) : null}
          {onlineProctor_2 ? (
            <div
              className="proctor_2"
              onClick={() => handleProctorUrlClick(onlineProctor_2)}
            >
              <Typography
                label="Online Proctor 1.5x Timer"
                variant="h9Book"
                styles="custom-proctor-typography-style"
              />
            </div>
          ) : null}
          {onlineProctor_3 ? (
            <div
              className="proctor_3"
              onClick={() => handleProctorUrlClick(onlineProctor_3)}
            >
              <Typography
                label="Online Proctor 2x Timer"
                variant="h9Book"
                styles="custom-proctor-typography-style"
              />
            </div>
          ) : null}
        </div>
      ) : null}
    </div>
  );
};
